import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ScoringMethodPopup } from './ScoringMethodPopup';

export const SCORING_METHOD_POPUP = Symbol('SCORING_METHOD');

export const useScoringMethodPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(SCORING_METHOD_POPUP, ScoringMethodPopup);
  });

  const selectScoringMethod = useCallback(
    ({
      initialValue,
      contentType,
      generationTool,
      assetType,
      onSubmit,
      onApplyAll,
      ...restProps
    }) => {
      popups.openPopup(SCORING_METHOD_POPUP, {
        initialValue,
        contentType,
        generationTool,
        assetType,
        ...restProps,

        onSubmit: (result) => {
          popups.closePopup(SCORING_METHOD_POPUP);
          onSubmit(result);
        },
        onClose: () => {
          popups.closePopup(SCORING_METHOD_POPUP);
        },
        onApplyAll,
      });
    },
    [popups]
  );

  return {
    selectScoringMethod,
  };
};
